import * as React from "react";
import { FormattedMessage } from "react-intl";

import { Button, ButtonToolbar, Modal } from "react-bootstrap";

/* eslint-disable import/no-webpack-loader-syntax */
import CloseIcon from "-!svg-react-loader!../../images/icn-close.svg";
/* eslint-enable import/no-webpack-loader-syntax */

import "./style.css";

import { ReportDto } from "../../services";
import ReportPreview, { ReportPreviewError } from "../report-preview";

export interface IReportPreviewModalProps {
  show: boolean;
  handleHide: () => void;
  handleKeyPress: (event: React.KeyboardEvent<Modal> | undefined) => void;
  handlePrint: () => void;
  handleDownload: () => void;
  report: ReportDto;
}

export interface IReportPreviewModalState {
  error: string | undefined;
  isModalVisible: boolean;
}

class ReportPreviewModal extends React.Component<IReportPreviewModalProps, IReportPreviewModalState> {
  constructor(props: IReportPreviewModalProps) {
    super(props);

    this.state = { isModalVisible: this.props.show, error: undefined };
  }

  public componentWillReceiveProps(nextProps: IReportPreviewModalProps, nextContext: any) {
    this.setState({ error: undefined });
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error: error.message });
  }

  public render() {
    return (
      <React.Fragment>
        <Modal
          onKeyPress={this.props.handleKeyPress}
          onHide={this.props.handleHide}
          dialogClassName={this.state.error ? "small-modal error-modal" : "report-preview-modal"}
          {...this.props}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-lg">
              {!this.state.error && (
                <ButtonToolbar>
                  {/* Standard button */}
                  <Button
                    className="image-button print-button"
                    onClick={e => {
                      e.stopPropagation();
                      this.props.handlePrint();
                    }}
                  >
                    Print
                  </Button>

                  {/* Provides extra visual weight and identifies the primary action in a set of buttons */}
                  <Button
                    className="image-button download-button"
                    onClick={e => {
                      e.stopPropagation();
                      this.props.handleDownload();
                    }}
                  >
                    <FormattedMessage id="report-preview.button.download" defaultMessage="Download" />
                  </Button>
                </ButtonToolbar>
              )}

              <a className="custom-close" onClick={this.props.handleHide}>
                <CloseIcon />
              </a>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.error !== undefined ? (
              ReportPreviewError
            ) : (
              <ReportPreview report={this.props.report} isSmallWindow={false} />
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ReportPreviewModal;



// WEBPACK FOOTER //
// ./src/components/report-preview-modal/index.tsx